<template>
  <!-- 生态伙伴 -->
  <div>
    <pageHeader :headerImg="config.headerImg" :headerTitle="config.headerTitle" :headerDesc="config.headerDesc">
    </pageHeader>
    <div class="content">
      <div class="content-one">
        <div class="content-one-left">
          <div class="content-title">{{ config.contentTitle }}</div>
          <div class="content-desc">{{ config.contentDesc }}</div>
          <div class="content-btn eno-common-button" @click="toPage('/serviceSupportDetail')">
            {{ config.contentBtn }}
            <i class="el-icon-right"></i>
          </div>
        </div>
        <img :src="config.contentSrc" alt="">
      </div>
      <div class="content-two">
        <div v-for="(downItem, index) in config.contentDownList.slice((pageNum - 1) * pagesize, pageNum * pagesize)"
             :key="index" class="content-two-item" title="点击下载" @click="toPage(`/downInfo?title=`+downItem.title)">
          <el-image :src="downItem.src" :key="downItem.src" lazy></el-image>
          <div class="content-two-title">《{{ downItem.title }}》</div>
          <!--  <div class="eno-common-button">
              下载资料
              <i class="el-icon-right"></i>
          </div> -->
        </div>
      </div>
      <enoPagination :pageNum="pageNum" :pagesize="pagesize" :total="config.contentDownList.length"
                     @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></enoPagination>
    </div>
    <appService></appService>
  </div>
</template>

<script>
import {config} from './service_support'
import pageHeader from '../common/page_header'
import enoPagination from '../common/eno_pagination'
import appService from '../common/appService.vue'
import {downloadDoc, toPage} from '@/utils'

export default {
  name: '',
  components: {pageHeader, enoPagination, appService,},
  data() {
    return {
      config: config,
      pageNum: 1,
      pagesize: 10,
    };
  },
  computed: {},
  watch: {},
  methods: {
    toPage,
    downloadDoc,
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.pageNum = val
    },
  },
};
</script>

<style scoped lang="less">
.content {
  padding: 100px;

  .content-one {
    background: @grayBgColor;
    display: flex;

    .content-one-left {
      margin: 203px 0 0 87px;
    }

    .content-title {
      margin-bottom: 60px;
      font-size: 40px;
    }

    .content-desc {
      font-size: 20px;
      margin: 36px 0 60px;
    }

    .content-btn {
      font-weight: 500;

      .el-icon-right {
        margin-left: 10px;
      }
    }
  }

  .content-two {
    margin-top: 16px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    border-collapse: collapse;
    grid-column-gap: 94px;

    .content-two-item {
      margin-top: 60px;
      cursor: pointer;

      .content-two-title {
        margin: 15px 0;
        font-size: @fontSize16;
      }
    }

  }

}

@media @mobile {
  .content {
    padding: 30px 16px;

    .content-one {
      flex-direction: column;
      background: @grayBgColor;
      padding: 20px 16px;

      .content-one-left {
        margin: 20px 0 30px;
        padding: 0;
      }

      .content-title {
        font-size: 24px;
        margin-bottom: 20px;
        line-height: 1.3;
      }

      .content-desc {
        font-size: 16px;
        margin: 16px 0 30px;
        line-height: 1.5;
      }

      .content-btn {
        font-size: 16px;
        padding: 8px 16px;

        .el-icon-right {
          margin-left: 8px;
          font-size: 14px;
        }
      }

      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }

    .content-two {
      margin-top: 20px;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 16px;
      grid-row-gap: 20px;

      .content-two-item {
        margin-top: 0;

        el-image {
          width: 100%;
          height: auto;
        }

        .content-two-title {
          margin: 10px 0;
          font-size: 14px;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
